import styled from 'styled-components';
import { alpha, ANIMATION_CURVE, ANIMATION_DURATION, getToken, ZIndex } from '@optimus-web/common';

interface LoadingOverlayProps {
    fixed?: boolean;
    show?: boolean;
}

export const LoadingOverlay = styled.div.attrs({ tabIndex: -1 })<LoadingOverlayProps>`
    visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
    position: ${({ fixed }) => (fixed ? 'fixed' : 'absolute')};
    background-color: ${({ theme }) =>
        alpha(getToken('backgroundInteractiveNeutralSubtleDefault')({ theme }), getToken('opacity800')({ theme }))};
    border-radius: inherit;
    opacity: ${({ show, theme }) => getToken(show ? 'opacity1000' : 'opacity0')({ theme })};
    transition-property: opacity, visibility;
    transition-duration: ${ANIMATION_DURATION.fast}ms;
    transition-timing-function: ${ANIMATION_CURVE.default};
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: ${ZIndex.Highest};
`;
